(ns frontend.ui.component.lp-portal.card.style
  (:require
   [frontend.ui.component.grid.style :as grid]
   [frontend.ui.style.theme.core :as theme]
   [garden.units :refer [px]]))

;; This component is specific to LP Portal so colors don't need to refer to `[:table :tr]` but
;; can directly use `[:palette :grey-10]` as this component will never use any other theme.

(defn simple-body
  [props]
  {:border           "1px solid"
   :border-radius    "15px"
   :padding          "16px"
   :background-color (or (:background-color props)
                         (theme/color [:content-card :body :bg]))
   :border-color     (theme/color [:content-card :body :border])
  })

(def ^:private width-too-small
  {:screen :only :max-width (px 992)})

(defn children-row
  []
  (with-meta
    {:display        "flex"
     :flex-direction "row"
     :border         "1px solid"
     :border-color   (theme/color [:content-card :row :border])
     :border-radius  "16px"}
    {:media
     {width-too-small
      {:flex-direction "column"}}}))

(defn main-child
  [split]
  (with-meta
    {:width            (grid/->width split)
     :padding          "16px"
     :background-color (theme/color [:content-card :child :primary :bg])
     :border-radius    "16px 0 0 16px"}
    {:media
     {width-too-small
      {:width         "100%"
       :border-radius "16px 16px 0 0"}}}))

(defn secondary-child
  [split]
  (with-meta
    {:width             (grid/->width split)
     :background-color  (theme/color [:content-card :child :secondary :bg])
     :padding           "16px"
     :border-radius     "0 16px 16px 0"
     :border-left       "1px solid"
     :border-left-color (theme/color [:content-card :row :border])}
    {:media
     {width-too-small
      {:width         "100%"
       :border-radius "0 0 16px 16px"}}}))

(defn card
  [blank-title?]
  (merge {:min-width   0
          :width       "100%"
          :padding     "8px 0 0"
          :font-size   "14px"
          :line-height "2"}
         (when blank-title?
           {:margin-top "-20px"})))

(defn title
  []
  {:padding        "6px"
   :color          (theme/color [:content-card :title :color])
   :font-size      "14px"
   :letter-spacing "2.2px"
   :font-weight    "bold"
   :height         "45px"                                   ;; 2 x padding + font-size * line-height = 2 * 12 + 14 * 1.5
   :line-height    1.5
   :text-transform :uppercase})


(defn checkbox-wrapper
  []
  {:display        "flex"
   :align-items    "center"
   :padding-bottom "12px"})

(defn checkbox-label
  []
  {:display       "block"
   :padding-right "8px"})

(defn checkbox-container
  []
  {:color (theme/color [:lp-editor :checkbox :checked])})

(defn spacing-top-bottom
  []
  {:padding "16px 0"})


